/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from 'react';
import { InputField, Label, StyledInput, InputWrapper, CloseIcon, ErrorMessage } from "./Input/Input";
import Dropdown from "../../Dropdown";
import "./Input/Input.css";
import "./inputv2.scss";
import Images from "../../../config/images";

import { Popup } from 'semantic-ui-react'

const phoneOptions = { 1: "+1", 52: "+52", 44: "+44" };
let timer;

class Input extends Component {
// const Input = (props) => {

  constructor(props) {
    super(props);
    this.state = {
      typingInProgress: false,
      focused: false,
      inputReady: props.value?true:false
    }
  }

  numbsOnly = (str) => {
    return !/^[0-9 -]*$/.test(str);
  }; // Ensure string has only numbers
  
  textOnly = (str) => {
    return !/^[a-zA-Z ,.]*$/.test(str);
  }; // Ensure string has only alphabet characters

  getPhoneBox = () => {
    const { handleISDUPdate, isdCode } = this.props;
    return <Dropdown value={phoneOptions[isdCode ? isdCode : 1]} handleSelect={(e) => handleISDUPdate(e)} list={phoneOptions} style={{ marginRight: "5px", minWidth: "75px", maxWidth: "max-content" }} phone rounded />;
  };

  getClasses() {
    const { hasError, size } = this.props;
    const {typingInProgress, focused} = this.state;
    let className = "inputWrapper";
    if(typingInProgress) {
      className += " typingInProgress";
    }
    if(hasError) {
      className += " inputWrapperWithError";
    }
    if(focused) {
      className += " inputFocussed";
    }

    if(size) {
      className += " size-" + size;
    }
    return className;
  }

  render() {
    const { name, wrapperStyle, inputStyle, buttonStyle, handleISDUPdate, phone, isdCode, topLabel, labelStyle, charsOnly, singleElement, topElement, bottomElement, leftElement, rightElement, rowElement, onChange, error, numbersOnly, limit, password, disabled, placeholder, required, rounded, hasError, tabIndex, id, showErrorInPopup, label, value, topLabelClassNames, onBlur } = this.props;
    const {typingInProgress, inputReady} = this.state;
    let allProps = {...this.props};
    delete allProps.className;

    return (
      <InputField topLabel={topLabel} className={this.getClasses() + " " + this.props.topLabelClassNames} onClick={()=> this.setState({"inputReady": true})} data-input-ready={inputReady}>
        <Label topLabel={topLabel} style={labelStyle} hasError={hasError} rounded={rounded} className="labelWrapper">
          <p className="labelEl">{label}</p>
          {hasError && rounded && !showErrorInPopup && <ErrorMessage className="errorMessage">{hasError.message}</ErrorMessage>}
        </Label>
        {disabled?<img className="lockIcon" src={Images.lockIcon}></img>:null}
        {showErrorInPopup && hasError && <Popup
          trigger={<img className="errorIcon" src={Images.errorIcon}></img>}
          content={hasError.message}
        />}
        {inputReady && <InputWrapper>
          {phone && this.getPhoneBox()}
          <StyledInput
            id={id}
            autoFocus
            style={inputStyle}
            phone={phone}
            placeholder={placeholder}
            type={password ? "password" : "text"}
            value={value}
            topElement={topElement}
            topLabel={topLabel}
            label={label}
            bottomElement={bottomElement}
            leftElement={leftElement}
            rightElement={rightElement}
            rowElement={rowElement}
            rounded={rounded}
            error={error}
            disabled={disabled}
            required={required}
            hasError={hasError}
            maxLength={limit || null}
            singleElement={singleElement}
            tabIndex={disabled ? -1 : (tabIndex || 0)}
            className={"inputEl " + this.props.className}
            {...allProps}
            onFocus={(e) => {
                this.setState({focused: true})
              }
            }
            onBlur={(e) => {
                // this.setState({focused: false})
                
                onBlur && onBlur()
              }
            }
            onChange={(e) => {
              
              console.log("Onchange triggered")
              this.setState({typingInProgress: true})
              window.clearTimeout(timer);
              timer = setTimeout(()=>{
                this.setState({typingInProgress: false})
              },1000);

              if (numbersOnly || phone) {
                if (limit && e.target.value.length > limit) return; // limit (HTML doesn't allow this normally, so we can't use maxLength or min/max)
                if (this.numbsOnly(e.target.value)) return; // Return if we want numbers only
                if (phone && e.target.value.length > 20) return; // Return if 'phone' length is greater than 10
              }
              if (charsOnly) {
                // If we want characters only
                if (this.textOnly(e.target.value)) return; // Return if we detect a number or symbol in string
              }

              onChange(name, e.target.value);
            }}
          />
          {!disabled && <CloseIcon style={buttonStyle} label={label} className="close icon" onClick={() => !disabled && onChange("")}></CloseIcon>}
        </InputWrapper>}
      </InputField>
    );
  }
}

// This export will be picked up in ./index.js
export default Input;
